import React, {CSSProperties, ReactNode} from 'react';
import {COLORS} from '../../../constants/colors';
import {DrawerProps} from '../Drawer/Drawer';
import {DropDownProps} from '../Dropdown/Dropdown';
import {FlyoutProps} from '../Flyout/Flyout';
import {ModalDialogProps} from '../ModalDialog/ModalDialog';
import {OpenerType} from './ContentOpener';

export interface ContentPopperBaseProps {
  ['data-testid']?: string;
  className?: string;
  style?: CSSProperties;

  // content nodes
  openerContent?: ReactNode;
  headerContent?: ReactNode;
  bodyContent?: ReactNode;
  footerContent?: ReactNode; // only available for ModalDialog, Flyout and Drawer

  onGoBack?: VoidFunction;
  /* This is always required on Flyout, as users can drag it down to close */
  onClose: VoidFunction;
  onOpenerClick?: VoidFunction;

  /**
   * Only applicable for flyout, only set in edge cases, e.g. when header has extra content and close button should be hidden
   */
  hideCloseButton?: boolean;

  open: boolean;
  isActive?: boolean;

  // sets the priority for the focus trap when multiple popovers are open, similar to z-index. Popovers with a higher priority value will receive focus before others
  popoverPriority?: number;
  /**
   * Only applicable for modal and flyout
   */
  renderInPortal?: boolean;
  aboveHeaderElement?: ReactNode;
  /**
   * Only applicable for drawer
   */
  slideDirection?: 'left' | 'right';
  preventAnimation?: boolean;

  /**
   * Only applicable for Modal
   */
  fixedSmallWidth?: boolean;
  preventSlideUpAnimation?: boolean;
  contentFitWidth?: boolean;
  animated?: boolean;

  /**
   * Only applicable for Dropdown
   */
  centerDropDownContent?: boolean;
  forceContentOpenerGreyBorder?: boolean;
  openerType?: OpenerType;
  forceContentOpenerIconColor?: keyof typeof COLORS;
}

export interface ContentPopperProps extends ContentPopperBaseProps {
  LayoutComponent:
    | React.FC<FlyoutProps>
    | React.FC<DropDownProps>
    | React.FC<ModalDialogProps>
    | React.FC<DrawerProps>;
}

export const ContentPopper: React.FC<ContentPopperProps> = ({
  LayoutComponent,
  ...props
}) => <LayoutComponent {...props} />;
